import { useMutationState } from '@tanstack/react-query'

export function usePendingMutations() {
  const pending = useMutationState({
    filters: { status: 'pending' },
    select: (mutation) => mutation.state.status,
  })

  const paused = useMutationState({
    filters: { status: 'pending' },
    select: (mutation) => mutation.state.isPaused,
  })

  const pausedCount = paused.filter(Boolean).length

  return {
    pendingCount: pending.length,
    pausedCount,
    hasPending: pending.length > 0,
  }
}
